var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTeamMemberPhone = function SvgTeamMemberPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    fillRule: "evenodd",
    d: "M4.6 7.4a10.2 10.2 0 0 0 2.41 1.78l1.57-1.6 2.86.66c.3.07.56.25.56.55v2.83c0 .11-.08.2-.2.23-2.67.57-6-.52-8.56-3.09C.68 6.2-.42 2.86.14.2.18.08.28 0 .39 0h2.83c.3 0 .48.26.55.56l.66 2.86-1.6 1.57a9.93 9.93 0 0 0 1.79 2.4Z",
    clipRule: "evenodd"
  })));
};
export default SvgTeamMemberPhone;